module.exports = __webpack_public_path__ + "img/closeIconWhite.b4f192f1.svg";